import Backbone from 'backbone'
import _ from 'lodash'
import template from 'scoreboard/charts/edit/serie/serie-period-form.hbs'
import CalendarRangeSelector from 'scoreboard/components/calendar-range-selector'
import unwrapModel from 'scoreboard/components/unwrap-model'
import calendars from 'scoreboard/components/calendars'
import i18n from 'scoreboard/components/i18n'

const SeriePeriodForm = Backbone.View.extend({
	initialize: function (options = {}) {
		this.calendarId = options.calendarId
	},

	render: function() {
		const title = this._getTitle()
		this.$el.empty().append(template({
			title
		}))

		this.calendarRangeSelector = new CalendarRangeSelector({
			range: this._translateSeriePeriodToSelectorRange(this.model),
			singlePeriod: true,
			allowAppCalendar: true
		})

		this.$('.period').prepend(this.calendarRangeSelector.el)
		this.calendarRangeSelector.render()
	},

	_getTitle: function() {
		const calender = calendars.calendarsById[this.calendarId]
		const specificTitle =
			i18n.get(`charts.choose.${_.camelCase(calender.type)}`)
		return specificTitle || i18n.get(`charts.choose.generic`)
	},

	/**
	 * @param {ChartDesignerSeriePeriod} period
	 * @return {{allowAppCalendar: boolean, calendarId: number, last: boolean,
	 * singlePeriod: boolean, start: boolean, end: boolean, first: boolean,
	 * relative: boolean}}
	 * @private
	 *
	 * Put the serie period into a form that can be edited by
	 * CalendarRangeSelector.
	 */
	_translateSeriePeriodToSelectorRange: function(period) {
		const periodId = period.get('periodId')
		const periodDelta = period.get('periodDelta')
		const [first, relative] =
			(_.isNil(periodDelta) ? [periodId, false] : [periodDelta, true])
		const [start, end, last] = [first, first, first]
		return {
			singlePeriod: true,
			allowAppCalendar: true,
			relative,
			calendarId: this.calendarId,
			first,
			last,
			start,
			end
		}
	},

	/**
	 * @param selectorRange contains edits made to the period
	 * @param {ChartDesignerSeriePeriod} period to be updated from the range
	 * @private
	 *
	 * Apply the model, from a CalendarRangeSelector, to the given serie period.
	 */
	_applySelectorRangeToPeriod: function(selectorRange, period) {
		if (selectorRange.relative) {
			period.set('periodDelta', selectorRange.first)
			period.set('periodId', undefined)
		} else {
			period.set('periodId', selectorRange.first)
			period.set('periodDelta', undefined)
		}
	},

	getPeriod: function() {
		const selectorRange = unwrapModel(this.calendarRangeSelector.model)
		const periodCopy = _.clone(this.model)
		this._applySelectorRangeToPeriod(selectorRange, periodCopy)
		return periodCopy
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.calendarRangeSelector], 'remove')
	}
})

export default SeriePeriodForm
SeriePeriodForm.__filename__ = 'charts/edit/serie/serie-period-form.js'
